module.exports = __webpack_public_path__ + "img/gol.be54c530.svg";